import React, { useState } from "react";
import { FaGithub, FaLinkedin, FaAngellist } from "react-icons/fa";

const icons = [
  { id: 1, icon: <FaGithub />, url: "https://github.com/mwafrika", label: "GitHub" },
  { id: 2, icon: <FaLinkedin />, url: "https://www.linkedin.com/in/mwafrika-mufungizi", label: "LinkedIn" },
  { id: 3, icon: <FaAngellist />, url: "https://angel.co/u/mwafrika-mufungizi", label: "AngelList" },
];

const FloatingButton = () => {
  const [show, setShow] = useState(false);

  return (
    <div className="fixed top-[5.5rem] left-4 z-[998] md:hidden flex flex-col items-center gap-3">
      {/* Toggle — plus → X with rotate */}
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Close social links" : "Open social links"}
        aria-expanded={show}
        className={`social-icon w-10 h-10 rounded-full bg-gradient-to-tr from-violet-600 to-indigo-500 text-white shadow-lg shadow-violet-500/30 focus:outline-none focus:ring-2 focus:ring-violet-400 transition-all duration-300 flex items-center justify-center ${
          show ? "rotate-45" : "rotate-0"
        }`}
      >
        <svg aria-hidden="true" className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
      </button>

      {/* Social links — staggered scale-in */}
      {icons.map(({ id, icon, url, label }, i) => (
        <a
          key={id}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="social-icon w-9 h-9 rounded-full bg-slate-800 dark:bg-white text-gray-300 dark:text-slate-600 border border-slate-700 dark:border-slate-200 shadow-md hover:bg-violet-600 hover:text-white hover:border-violet-500 dark:hover:bg-violet-50 dark:hover:text-violet-600 dark:hover:border-violet-300 text-base flex items-center justify-center"
          style={{
            transitionDelay: show ? `${i * 50}ms` : "0ms",
            opacity: show ? 1 : 0,
            transform: show ? "scale(1) translateY(0)" : "scale(0.5) translateY(-8px)",
            pointerEvents: show ? "auto" : "none",
          }}
        >
          {icon}
        </a>
      ))}
    </div>
  );
};

export default FloatingButton;
